Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get AtlasError () {
        return AtlasError;
    },
    get AtlasFetchError () {
        return AtlasFetchError;
    },
    get AtlasParseError () {
        return AtlasParseError;
    }
});
class AtlasError extends Error {
    constructor(message){
        super(message);
        this.name = 'AtlasError';
    }
}
class AtlasFetchError extends AtlasError {
    constructor(message){
        super(message);
        this.name = 'AtlasFetchError';
    }
}
class AtlasParseError extends AtlasError {
    constructor(message){
        super(message);
        this.name = 'AtlasParseError';
    }
}
